import React from 'react';
import { Link } from 'react-router-dom';

// Components
import DarkModeSwitcher from './DarkModeSwitcher';
import DropdownUser from './DropdownUser';
import HamburgToggle from '../HamburgToggle/HamburgToggle';
import IconFire from '../Icons/IconFire/IconFire';
import EditModeToggle from '../EditModeToggle/EditModeToggle';
// import HeaderSearch from '../HeaderSearch/HeaderSearch';

type HeaderProps = {
  sidebarOpen: boolean;
  setSidebarOpen: (sidebarState: boolean) => void;
}

const Header: React.FC<HeaderProps> = (props) => {
  const { sidebarOpen, setSidebarOpen } = props;

  const changeStateSideBar = (e) => {
    e.stopPropagation();
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <header className="sticky top-0 z-999 flex w-full h-17 bg-white drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none">
      <div className="relative flex flex-grow items-center justify-between lg:justify-end px-4 py-4 shadow-2 md:px-6 2xl:px-11">
        <div className="flex items-center gap-2 sm:gap-4 lg:hidden">
          <HamburgToggle isOpen={sidebarOpen} onClick={changeStateSideBar} />
          <Link className="block flex-shrink-0 lg:hidden" to="/">
            <IconFire />
          </Link>
        </div>
        {/* <HeaderSearch /> */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <EditModeToggle />
        </div>
        <div className="flex items-center gap-3 2xsm:gap-7">
          <DarkModeSwitcher />
          <DropdownUser />
        </div>
      </div>
    </header>
  );
};

export default Header;
